export const csvCell = value => {
    let text = String(value ?? '');
    if (/^[\s]*[=+\-@\t\r]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
};
export const downloadBlob = (blob, name) => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = name;
    document.body.appendChild(anchor); anchor.click(); anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const downloadCsv = (rows, name) => downloadBlob(new Blob(['\uFEFF' + rows.map(row => row.map(csvCell).join(',')).join('\r\n')], {type: 'text/csv;charset=utf-8'}), name);
export function parseCsv(text) {
    const rows = []; let row = [], cell = '', quoted = false;
    text = text.replace(/^\uFEFF/, '');
    for (let i=0; i<text.length; i++) {
        const char = text[i];
        if (char === '"') {
            if (quoted && text[i+1] === '"') { cell += '"'; i++; }
            else quoted = !quoted;
        } else if (!quoted && (char === ',' || char === '\n' || char === '\r')) {
            row.push(cell); cell = '';
            if (char !== ',') { if (row.some(value => value.trim())) rows.push(row); row = []; if (char === '\r' && text[i+1] === '\n') i++; }
        } else cell += char;
    }
    if (quoted) throw new Error('A quoted CSV field was not closed.');
    row.push(cell); if (row.some(value => value.trim())) rows.push(row);
    return rows;
}

// ZIP "store" format keeps QR PNGs portable without another runtime dependency.
export function zipFiles(files) {
    const chunks = [], central = []; let offset = 0, directorySize = 0;
    const header = (length, fields) => {const bytes = new Uint8Array(length), view = new DataView(bytes.buffer); fields.forEach(([at,value,size]) => size === 2 ? view.setUint16(at,value,true) : view.setUint32(at,value,true)); return bytes;};
    const crc32 = bytes => {let crc=0xffffffff; for(const byte of bytes){crc ^= byte; for(let bit=0;bit<8;bit++) crc=(crc>>>1)^((crc&1)?0xedb88320:0);}return (crc^0xffffffff)>>>0;};
    for (const file of files) {
        const name = new TextEncoder().encode(file.name), data = file.data, crc=crc32(data);
        const local = header(30, [[0,0x04034b50,4],[4,20,2],[6,0x800,2],[14,crc,4],[18,data.length,4],[22,data.length,4],[26,name.length,2]]);
        chunks.push(local,name,data);
        const entry = header(46, [[0,0x02014b50,4],[4,20,2],[6,20,2],[8,0x800,2],[16,crc,4],[20,data.length,4],[24,data.length,4],[28,name.length,2],[42,offset,4]]);
        central.push(entry,name); directorySize += entry.length+name.length; offset += local.length+name.length+data.length;
    }
    const end=header(22,[[0,0x06054b50,4],[8,files.length,2],[10,files.length,2],[12,directorySize,4],[16,offset,4]]);
    return new Blob([...chunks,...central,end],{type:'application/zip'});
}
